import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  license: string;
  realtor_company_license: string;
  company_side: 'seller' | 'buyer';
  period: Period;
};

type IndexResponse = {
  data: {
    agents: CompanyAndAgent[];
  };
};

export const show = async ({ license, realtor_company_license, ...params }: IndexParams) =>
  apiClient.get<IndexResponse>(
    `/companies/${license}/realtor_companies/${realtor_company_license}`,
    { params }
  );
